export const PRIVACY_POLICY_LINK = {
  uk: '/uk/privacy',
  fr: '/fr/politique-de-confidentialite',
};

export const VWFS_PRIVACY_POLICY_LINK = {
  vwfsPrivacy:
    'https://www.vwfs.fr/espace-client/nos-formulaires/politique-donnees-personnelles.html',
};
